(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["wunschmotiv-upload"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", () => {

  document.querySelectorAll(".eb-upload").forEach((wrapper) => {

    const input = wrapper.querySelector(".eb-upload-input");

    if (!input) return;

    const content = wrapper.querySelector(".eb-upload-content");

    const success = wrapper.querySelector(".eb-upload-success");

    let fileInfo = wrapper.querySelector(".eb-upload-file");

    if (!success) {

      fileInfo = document.createElement("div");
      fileInfo.className = "eb-upload-success";

      content.appendChild(fileInfo);

    }

    input.addEventListener("change", function () {

      if (!this.files.length) {

        fileInfo.style.display = "none";
        return;

      }

      const file = this.files[0];

      fileInfo.style.display = "flex";

      fileInfo.innerHTML = `
        <span style="font-size:22px;">✅</span>
        <div>
          <strong>${file.name}</strong><br>
          <small>${Math.round(file.size / 1024)} KB</small>
        </div>
      `;

    });

  });

});
  } catch(e) { console.error(e); }
})();

})();
